// extracted by mini-css-extract-plugin
export default {"dialog":"LoadingModal_dialog__MjqA0"};